import { render, staticRenderFns } from "./PMPlaceholder.vue?vue&type=template&id=3e4997dc&"
import script from "./PMPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./PMPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./PMPlaceholder.vue?vue&type=style&index=0&id=3e4997dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports